'use client'

import { createContext } from 'react'

import { PaginationDto } from '@marketplace-web/domain/pagination-data'
import { UiState } from '@marketplace-web/shared/ui-state'
import { CatalogItemDto } from 'types/dtos/catalog-item'

export type ItemsCatalogContextType = {
  items: Array<CatalogItemDto> | undefined
  uiState: UiState
  error: string | undefined
  pagination: PaginationDto | undefined
}

const ItemsCatalogContext = createContext<ItemsCatalogContextType>({
  uiState: UiState.Idle,
  items: undefined,
  pagination: undefined,
  error: undefined,
})

export default ItemsCatalogContext
